<template>
    <footer class="footer">
        <div class="footer-content">
            <div class="footer-section company-info">
                <div class="logo" @click="navigateToHome()">
                  <img src="@/assets/icon/companyfooter.png" alt="Company Logo" height="40">
                    <div class="logo-title">
                      <span>GrowthSoft</span>
                    </div>
                </div>
                <p v-html="$t('address')"></p>
                <ul><li><a href="https://maps.app.goo.gl/bL7HttKZ965KqBFAA" class="others-link" target="_blank" rel="noopener noreferrer">{{ $t('maplinks') }}</a></li></ul>
                <p></p>
                <p>{{ $t('phone') }}</p>
                <p>{{ $t('email') }}</p>
                <button @click="navigateToSection('contactInfo', '')">{{ $t('contact') }}</button>
                <button @click="navigateToSection('recruitmentInfo', '')">{{ $t('joinus') }}</button>
            </div>
            <div class="footer-section links">
                <ul>
                    <li @click="navigateToSection('', '')"><a href="#">{{ $t('home') }}</a></li>
                    <li @click="navigateToSection('companyInfo', '')"><a href="#">{{ $t('companyInfo') }}</a></li>
                    <li @click="navigateToSection('solutionInfo', '')"><a href="#">{{ $t('solutions') }}</a></li>
                    <li @click="navigateToSection('recruitmentInfo', '')"><a href="#">{{ $t('recruitmentInfo') }}</a></li>
                    <li @click="navigateToSection('contactInfo', '')"><a href="#">{{ $t('contact') }}</a></li>
                </ul>
            </div>
            <div class="footer-section sublinks">
                <h3>{{ $t('companyInfo') }}</h3>
                <ul>
                    <!-- <li class="@click="navigateToSection('companyInfo','achievements')">{{ $t('achievementsNavBar') }}</li> -->
                    <li @click="navigateToSection('companyInfo', 'vision')">{{ $t('visionNavBar') }}</li>
                    <li @click="navigateToSection('companyInfo','companyprofile')">{{ $t('companyProfileNavBar') }}</li>
                    <li @click="navigateToSection('companyInfo', 'welfare')">{{ $t('welfareNavBar') }}</li>
                    <li @click="navigateToSection('companyInfo', 'target')">{{ $t('targetNavBar') }}</li>
                    <li @click="navigateToSection('companyInfo', 'history')">{{ $t('historyNavBar') }}</li>
                </ul>
            </div>
            <div class="footer-section sublinks">
                <h3>{{ $t('itsolution') }}</h3>
                <ul>
                    <li @click="navigateToSection('solutionInfo', 'SES')">{{ $t('ses') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'AppDev')">{{ $t('appDev') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Skill')">{{ $t('skill') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Develop')">{{ $t('develop') }}</li>
                    <!-- <li @click="navigateToSection('solutionInfo', 'Dispatch')">{{ $t('dispatch') }}</li> -->
                </ul>
            </div>
            <!-- <div class="footer-section sublinks">
                <h3>{{ $t('t2solution') }}</h3>
                <ul>
                    <li @click="navigateToSection('solutionInfo', 'T2solution')">{{ $t('solutionInfo.t2solution.work01') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'T2solution')">{{ $t('solutionInfo.t2solution.work02') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'T2solution')">{{ $t('solutionInfo.t2solution.work03') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'T2solution')">{{ $t('solutionInfo.t2solution.work04') }}</li>
                </ul>
            </div> -->
            <!-- <div class="footer-section sublinks">
                <h3>{{ $t('line') }}</h3>
                <h3></h3>
                <h3>{{ $t('t1solution') }}</h3>
                <ul>
                    <li @click="navigateToSection('solutionInfo', 'Work0')">{{ $t('solutionInfo.t1solution.work0') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work1')">{{ $t('solutionInfo.t1solution.work1') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work2')">{{ $t('solutionInfo.t1solution.work2') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work3')">{{ $t('solutionInfo.t1solution.work3') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work4')">{{ $t('solutionInfo.t1solution.work4') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work5')">{{ $t('solutionInfo.t1solution.work5') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work6')">{{ $t('solutionInfo.t1solution.work6') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work7')">{{ $t('solutionInfo.t1solution.work7') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work8')">{{ $t('solutionInfo.t1solution.work8') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work9')">{{ $t('solutionInfo.t1solution.work9') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work10')">{{ $t('solutionInfo.t1solution.work10') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work11')">{{ $t('solutionInfo.t1solution.work11') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work12')">{{ $t('solutionInfo.t1solution.work12') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work13')">{{ $t('solutionInfo.t1solution.work13') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work14')">{{ $t('solutionInfo.t1solution.work14') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work15')">{{ $t('solutionInfo.t1solution.work15') }}</li>
                    <li @click="navigateToSection('solutionInfo', 'Work16')">{{ $t('solutionInfo.t1solution.work16') }}</li>
                </ul>
            </div> -->
        </div>
        <div class="footer-bottom">
            <p>{{ $t('copyright') }}</p>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterMenu',
    methods: {
        navigateToHome() {
          if (this.$route.path !== '/') {
            this.$router.push('/');
          } else {
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        },
        navigateToSection(router, subSectionId) {
            const targetPath = `/${router}`;
            const hash = subSectionId ? `#${subSectionId}` : '';
            const currentPath = this.$route.path;
            const currentHash = window.location.hash;

            if (currentPath !== targetPath) {
                this.$router.push(targetPath).then(() => {
                    if (subSectionId) {
                        location.hash = hash;
                    }
                });
            } else if (currentHash !== hash) {
                this.$router.replace({ hash: hash }).then(() => {
                    const element = document.getElementById(subSectionId);
                    if (element) {
                        element.scrollIntoView({ behavior: 'smooth' });
                    }
                });
            } else if (subSectionId && currentHash === hash) {
                const element = document.getElementById(subSectionId);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            } else {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    }
};
</script>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&display=swap');

.footer {
    background-color: #fff;
    padding: 2rem 0;
    color: #fff;
    background-color: #414c64e3;
    font-family: 'Noto Sans JP', sans-serif;
    font-weight: 400;

    .others-link {
      font-size: 18px;
      color: rgb(255, 255, 255);
      text-decoration: none;
    }

    .others-link:hover {
      color:rgb(182, 234, 147);
    }

    .logo {
      height: 40px;
      display: flex;
      cursor: pointer;
      span {
        font-size: 23px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 8px;
        background: linear-gradient(90deg,rgb(254, 254, 254),rgb(221, 254, 202),rgb(255, 255, 255));
        background-size: 150% auto;
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        animation: 
          gradient 3s linear infinite;
      }

      /* 标题科技感光效 */
      .logo-title  {
        position: relative;
        display: inline-block;
        padding: 0 -1em;
        color: rgb(255, 255, 255);
      }

      .logo-title ::after {
        content: '';
        position: absolute;
        bottom: 0.5px;
        left: 50%;
        width: 90%;
        height: 2px;
        background: linear-gradient(90deg, transparent,rgb(253, 254, 254), transparent);
        transform: translateX(-50%);
        animation: laserScan 0.5s infinite;
      }
    }

    button {
      margin-top: 30px;
      width: 200px;
      height: 74px;
      font-size: 18px;
      letter-spacing: 2px;
      font-weight: 400;
      font-family: 'Noto Sans JP', sans-serif;
      color: #fff;
      background-color: #414c6408;
      border: 1px #fff solid;
      border-radius: 1px;
      transition: background-color 0.3s ease, color 0.3s ease;
    }

    button:hover {
      color: #414c64;
      background-color: #fff;
      border: 1px #414c64 solid;
      border-radius: 1px;
      transition: background-color 0.3s ease, color 0.3s ease;
    }

    &-content {
        display: flex;
        justify-content: space-between;
        max-width: 1500px;
        margin: 0 auto;
        padding: 0 1rem;

        .footer-content {
          flex-direction: column; /* 改为垂直布局 */
          overflow: hidden; /* 防止内容溢出 */
        }

        .footer-section {
            width: 100%;
            max-width: 100%;
            flex: 1;
            margin-right: 2rem;
            padding: 20px 15px;
            box-sizing: border-box;
            white-space: normal;
            word-wrap: break-word;

            &.links,
            &.sublinks {
                position: relative;
                right: -5rem;

                ul {
                    list-style: none;
                    padding: 0;

                    li {
                        width: 15rem;
                        font-size: 18px;
                        margin-bottom: 0.5rem;
                        cursor: pointer;
                        &:hover {
                            color:rgb(182, 234, 147);
                            text-decoration: underline;
                        }

                        a {
                            color: #fff;
                            text-decoration: none;
                            font-size: 25px;
                            font-weight: 400;
                            font-family: 'Noto Sans JP', sans-serif;

                            &:hover {
                                color:rgb(182, 234, 147);
                                text-decoration: underline;
                            }
                        }
                    }
                }
            }

            h2,
            h3 {
                margin-bottom: 1rem;
                font-weight: 400;
                font-size: 28px;
            }

            p {
                margin: 0.5rem 0;
                font-size: 20px;
            }
        }
    }

    &-bottom {
        text-align: center;
        padding: 1rem 0;
        margin-top: 2rem;

        p {
            margin: 0;
            font-family: 'Noto Sans JP', sans-serif;
        }
    }
}

@media (max-width: 768px) {
    .footer {
      &-content {
        padding-left: 10%;
        flex-direction: column; /* 垂直排列 */
        align-items: left; /* 对齐 */
        text-align: left; /* 文本 */
      }
  
      button {
        margin: 0 0 3rem 2; /* 调整间距 */
        width: 160px;
        height: 50px;
        font-size: 14px;
      }

      .footer-content {
        flex-direction: column; /* 改为垂直布局 */
        overflow: hidden; /* 防止内容溢出 */
      }
        
      .footer-section {
        margin: 0 0 1rem 0; /* 调整间距 */
        width: 100% !important; /* 强制占满宽度 */
        max-width: 100%;
        flex: none; /* 禁用弹性伸缩 */
        padding: 15px 20px; /* 统一内边距 */
        box-sizing: border-box;
    
        /* 处理内部内容换行 */
        white-space: normal;
        word-wrap: break-word;
  
        /* 如果是横向导航链接 */
        .sublinks {
          display: flex;
          flex-wrap: wrap; /* 允许换行 */
          gap: 10px; /* 现代浏览器间距 */
        }

        /* 兼容旧版浏览器 */
        .sublinks > * {
          margin: 5px;
          flex-shrink: 0; /* 防止内容挤压 */
        }

        &.sublinks {
            position: relative;
            left: 0;
        }
        
        &.links {
            position: relative;
            left: 0;

            ul {
                list-style: none;
                padding: 0;

                li {
                    width: 20rem;
                    margin-bottom: 0.5rem;
                    cursor: pointer;
                    &:hover {
                        color:rgb(182, 234, 147);
                        text-decoration: underline;
                    }

                    a {
                        color: #fff;
                        text-decoration: none;
                        font-size: 20px;
                        font-weight: 400;
                        font-family: 'Noto Sans JP', sans-serif;

                        &:hover {
                            color:rgb(182, 234, 147);
                            text-decoration: underline;
                        }
                    }
                }
            }
        }
  
        h2,
        h3 {
          width: 25rem;
          font-size: 22px;
        }
  
        p {
          font-size: 18px;
        }
      }
    }
}
</style>